import { render, staticRenderFns } from "./expenses_report.vue?vue&type=template&id=531e080d"
import script from "./expenses_report.vue?vue&type=script&lang=js"
export * from "./expenses_report.vue?vue&type=script&lang=js"
import style0 from "./expenses_report.vue?vue&type=style&index=0&id=531e080d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports